import { CalendarDaysIcon } from '@heroicons/react/20/solid'
import classNames from 'classnames'
import { formatDate } from 'app/date.utils'

export function DateComponent({
  value,
  dateOnly,
  format,
  className = ``,
  useLocalUtc,
  showIcon,
  timezone,
}: {
  value?: Date | string | null | moment.Moment
  dateOnly?: boolean
  format?: string
  className?: string
  useLocalUtc?: boolean
  showIcon?: boolean
  /** IANA zone to render the instant in, e.g. a location's `timezone`. */
  timezone?: string | null
}) {
  return (
    <span className={classNames(`flex items-center whitespace-nowrap text-left`, className)}>
      {showIcon && <CalendarDaysIcon className="mr-1.5 h-4 w-4" />}
      {formatDate({ value, dateOnly, format, useLocalUtc, timezone })}
    </span>
  )
}
